__turbopack_context__.v({
  "container": "HoursSection-module__i5BRMG__container",
  "day": "HoursSection-module__i5BRMG__day",
  "row": "HoursSection-module__i5BRMG__row",
  "schedule": "HoursSection-module__i5BRMG__schedule",
  "scheduleCard": "HoursSection-module__i5BRMG__scheduleCard",
  "section": "HoursSection-module__i5BRMG__section",
  "statusCard": "HoursSection-module__i5BRMG__statusCard",
  "statusClosed": "HoursSection-module__i5BRMG__statusClosed",
  "statusEyebrow": "HoursSection-module__i5BRMG__statusEyebrow",
  "statusIcon": "HoursSection-module__i5BRMG__statusIcon",
  "statusImage": "HoursSection-module__i5BRMG__statusImage",
  "statusOverlay": "HoursSection-module__i5BRMG__statusOverlay",
  "statusPanel": "HoursSection-module__i5BRMG__statusPanel",
  "statusText": "HoursSection-module__i5BRMG__statusText",
  "statusTitle": "HoursSection-module__i5BRMG__statusTitle",
  "time": "HoursSection-module__i5BRMG__time",
  "title": "HoursSection-module__i5BRMG__title",
});
